export default {
  psCustomerStatus: {
    sent_to_salesforce: "Sent to Salesforce",
    not_sent_to_salesforce: "Not Sent to Salesforce",
    uploading: "Uploading",
    extracting: "Extracting",
    analyzing: "Analyzing",
    completed: "Completed",
    invalid_file: "Invalid File",
  },
  psCustomerStatusColor: {
    sent_to_salesforce: "bg-green-400",
    not_sent_to_salesforce: "bg-yellow-400",
    uploading: "bg-yellow-400",
    extracting: "bg-yellow-400",
    analyzing: "bg-yellow-400",
    completed: "bg-green-400",
    invalid_file: "bg-red-400",
  },
  psCustomerServerGroundHogStatus: {
    sent_to_salesforce: {
      label: 'Sent to Salesforce',
      customClass: 'bg-green-400',
      severity: "success"
    },
    not_sent_to_salesforce: {
      label: 'Not sent to Salesforce',
      customClass: 'bg-yellow-400',
      severity: "warning"
    },
    uploading: {
      label: 'Uploading',
      customClass: 'bg-yellow-400',
      severity: "warning"
    },
    extracting: {
      label: 'Extracting',
      customClass: 'bg-yellow-400',
      severity: "warning"
    },
    analyzing: {
      label: 'Analyzing',
      customClass: 'bg-yellow-400',
      severity: "warning"
    },
    completed: {
      label: 'Completed',
      customClass: 'bg-green-400',
      severity: "success"
    },
    invalid_file: {
      label: 'Invalid File',
      customClass: 'bg-red-400',
      severity: "danger"
    },
    failed: {
      label: 'Failed',
      customClass: 'bg-red-400',
      severity: "danger"
    },
  },
  siteAssessmentFields: [
    {
      column_name: 'facility_name',
      index: 0,
      name: 'Facility Name',
      emoji: '',
      className: 'facility-name-image',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'care_unit',
      index: 1,
      name: 'Care Unit',
      emoji: '🐈',
      className: 'care-unit-image',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'device_type.new',
      index: 2,
      name: 'Device Type',
      emoji: '',
      className: 'device-type-image',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'manufacturer.new',
      index: 3,
      name: 'Manufacturer',
      emoji: '',
      className: 'manufacturer-image',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'model.new',
      index: 4,
      name: 'Device Model',
      emoji: '',
      className: 'device-model-image',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'original_model',
      index: 5,
      name: 'Original Model',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'device_count',
      index: 6,
      name: 'Device Count',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'sw_version',
      index: 7,
      name: 'SW Version',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'serial_no',
      index: 8,
      name: 'Serial No.',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'assesst_no',
      index: 9,
      name: 'Asset No.',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'supplier',
      index: 10,
      name: 'Supplier',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'floor',
      index: 11,
      name: 'Floor',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'room_bay_bed',
      index: 12,
      name: 'Room/Bay/Bed',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'location_id',
      index: 13,
      name: 'LocationID',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'fixed_mobile',
      index: 14,
      name: 'Fixed/Mobile',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'connected_to_cms_gw',
      index: 15,
      name: 'Connected to CMS/GW',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'network_ready',
      index: 16,
      name: 'Network Ready?',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'power_ready',
      index: 17,
      name: 'Power Ready?',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'mounting_solution',
      index: 18,
      name: 'Mounting Solution',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'hospital_comment',
      index: 19,
      name: 'Hospital Comment',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'capsule_comment',
      index: 20,
      name: 'Capsule Comment',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'supported.value',
      index: 21,
      name: 'Supported',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'default_connection',
      index: 22,
      name: 'Connection Type',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: false,
    },
    {
      column_name: 'application.value',
      index: 23,
      name: 'Application',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'required_cable.value',
      index: 24,
      name: 'Required Cable',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'suggested_solution.value',
      index: 25,
      name: 'Suggested Solution',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'supported_firmware.value',
      index: 26,
      name: 'Supported Firmware',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'ddi.value',
      index: 27,
      name: 'DDI Release',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: true,
    },
    {
      column_name: 'id',
      index: 28,
      name: 'Id',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: false,
    },
    {
      column_name: 'supported.color',
      index: 29,
      name: 'Supported Color',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: false,
    },
    {
      column_name: 'connection_type.color',
      index: 30,
      name: 'Connection Color',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: false,
    },
    {
      column_name: 'application.color',
      index: 31,
      name: 'Application Color',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: false,
    },
    {
      column_name: 'required_cable.color',
      index: 32,
      name: 'Required Cable Color',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: false,
    },
    {
      column_name: 'suggested_solution.color',
      index: 33,
      name: 'suggested Solution Color',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: false,
    },
    {
      column_name: 'supported_firmware.color',
      index: 34,
      name: 'Support Firmware Color',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: false,
    },
    {
      column_name: 'ddi.color',
      index: 35,
      name: 'DDI Color',
      emoji: '',
      className: '',
      isOutput: true,
      isPopulationFlag: false,
    },
    {
      column_name: 'auto_bed_count',
      index: 36,
      name: 'Auto Bed Count',
      emoji: '',
      className: '',
      isOutput: false,
      isPopulationFlag: false,
    },
    {
      column_name: 'manual_bed_count',
      index: 37,
      name: 'Manual Bed Count',
      emoji: '',
      className: '',
      isOutput: false,
      isPopulationFlag: false,
    },
    {
      column_name: 'device_category',
      index: 38,
      name: 'Device Category',
      emoji: '',
      className: '',
      isOutput: false,
      isPopulationFlag: false,
    },
    {
      column_name: 'ddi_release_status',
      index: 39,
      name: 'Release Status',
      emoji: '',
      className: '',
      isOutput: false,
      isPopulationFlag: false,
    },

  ],
  ruleFieldList: [
    {
      text: 'Facility Name',
      value: 'facility_name',
      type: 'string'
    },
    {
      text: 'Care Unit',
      value: 'care_unit',
      type: 'string'
    },
    {
      text: 'Device Type',
      value: 'device_type.new',
      type: 'string'
    },
    {
      text: 'Manufacturer',
      value: 'manufacturer.new',
      type: 'string'
    },
    {
      text: 'Model',
      value: 'model.new',
      type: 'string'
    },
    {
      text: 'Device Count',
      value: 'device_count',
      type: 'numeric'
    },
    {
      text: 'SW Version',
      value: 'sw_version',
      type: 'string'
    },
    {
      text: 'Serial Number',
      value: 'serial_number',
      type: 'numeric'
    },
    {
      text: 'Asset Number',
      value: 'asset_number',
      type: 'numeric'
    },
    {
      text: 'Supplier',
      value: 'supplier',
      type: 'string'
    },
    {
      text: 'Floor',
      value: 'floor',
      type: 'string'
    },
    {
      text: 'Room/Bay/Bed',
      value: 'room_bay_bed',
      type: 'string'
    },
    {
      text: 'LocationID',
      value: 'location_id',
      type: 'string'
    },
    {
      text: 'Fixed/Mobile',
      value: 'fixed_mobile',
      type: 'string'
    },
    {
      text: 'Connected to CMS/GW',
      value: 'connected_to_cms_gw',
      type: 'string'
    },
    {
      text: 'Network Ready?',
      value: 'network_ready',
      type: 'string'
    },
    {
      text: 'Power Ready?',
      value: 'power_ready',
      type: 'string'
    },
    {
      text: 'Mounting Solution',
      value: 'mounting_solution',
      type: 'string'
    },
    {
      text: 'Hospital Comment',
      value: 'hospital_comment',
      type: 'string'
    },
    {
      text: 'Capsule Comment',
      value: 'capsule_comment',
      type: 'string'
    },
    // removed duplicate as it's repeated in "actionFieldList"
    // {
    //   text: 'Suggested Soltuion',
    //   value: 'suggested_solution.value',
    //   type: 'string'
    // },
    // {
    //   text: 'Soltuion Model',
    //   value: 'solution_model.value',
    //   type: 'string'
    // },
  ],
  sfDDILibraryTableHeader: [
    {
      text: 'Manufacturer',
      value: 'Manufacturer'
    }, {
      text: 'DeviceType',
      value: 'DeviceType'
    }, {
      text: 'DeviceModel',
      value: 'DeviceModel'
    }, {
      text: 'Supported_firmware',
      value: 'Supported_firmware'
    }, {
      text: 'Application',
      value: 'Application'
    }, {
      text: 'ConnectionType',
      value: 'ConnectionType'
    }, {
      text: 'RequiredCable',
      value: 'RequiredCable'
    }, {
      text: 'DDIRelease',
      value: 'DDIRelease'
    }, {
      text: 'ReleaseDate',
      value: 'ReleaseDate'
    }, {
      text: 'New_Device_Manufacturer',
      value: 'New_Device_Manufacturer'
    }, {
      text: 'Device_Entry_in_DDI',
      value: 'Device_Entry_in_DDI'
    }, {
      text: 'Support_Status',
      value: 'Support_Status'
    }, {
      text: 'other_cable_vendor',
      value: 'other_cable_vendor'
    }, {
      text: 'Device_description',
      value: 'Device_description'
    },
    {
      text: 'Connection_Comments',
      value: 'Connection_Comments'
    },
    {
      text: 'DDI_Release_Status',
      value: 'DDI_Release_Status'
    },
    {
      text: 'Device_CreatedDate',
      value: 'Device_CreatedDate'
    },
    {
      text: 'Device_LastModifiedDate',
      value: 'Device_LastModifiedDate'
    },
    {
      text: 'Device_Image',
      value: 'Device_Image'
    },
    {
      text: 'Demo_mode',
      value: 'Demo_mode'
    },
    {
      text: 'Device_Pending_update',
      value: 'Device_Pending_update'
    },
    {
      text: 'Device_web_page__c',
      value: 'Device_web_page__c'
    },
    {
      text: 'Device_Passwords',
      value: 'Device_Passwords'
    },
    {
      text: 'Device_Settings',
      value: 'Device_Settings'
    },
    {
      text: 'connectivity_of_the_device_is_an_option__c',
      value: 'connectivity_of_the_device_is_an_option__c'
    },
    {
      text: 'Initial_support_date__c',
      value: 'Initial_support_date__c'
    },
    {
      text: 'is_designed_for_MRI__c',
      value: 'is_designed_for_MRI__c'
    },
    {
      text: 'Sorting_Field_for_Marketing_List__c',
      value: 'Sorting_Field_for_Marketing_List__c'
    },
    {
      text: 'Additional_Photos__c',
      value: 'Additional_Photos__c'
    },
    {
      text: 'Firmware_Version_Location__c',
      value: 'Firmware_Version_Location__c'
    },
    {
      text: 'Alarms_Support__c',
      value: 'Alarms_Support__c'
    },
    {
      text: 'Waveforms_Support__c',
      value: 'Waveforms_Support__c'
    },
    {
      text: 'SF_Device_ID',
      value: 'SF_Device_ID'
    },
    {
      text: 'Available_on_Philips_webportal__c',
      value: 'Available_on_Philips_webportal__c'
    },
  ],
  actionFieldList: [
    {
      text: 'Support Status',
      key: 'supported',
      value: 'supported.value',
      type: 'string',
      lookUpKey: 'Supportted_Status',
    },
    {
      text: 'Connection Type',
      key: 'connection_type',
      value: 'connection_type.value',
      type: 'string',
      lookUpKey: 'Connection_Type',
    },
    {
      text: 'Application',
      key: 'application',
      value: 'application.value',
      type: 'string',
      lookUpKey: 'Application',
    },
    {
      text: 'Required Cable',
      key: 'required_cable',
      value: 'required_cable.value',
      type: 'string',
      lookUpKey: 'Required_Cable',
    },
    {
      text: 'Suggested Solution',
      key: 'suggested_solution',
      value: 'suggested_solution.value',
      type: 'string',
      lookUpKey: 'Suggested_Solution',
    },
    {
      text: 'Supported Firmware',
      key: 'supported_firmware',
      value: 'supported_firmware.value',
      type: 'string',
      lookUpKey: 'Supported_Firmware',
    },
    {
      text: 'DDI',
      key: 'ddi',
      value: 'ddi.value',
      type: 'string',
      lookUpKey: 'DDI',
    },
    {
      text: 'Solution Model',
      key: 'solution_model',
      value: 'solution_model.value',
      type: 'string',
      lookUpKey: 'Solution_Model',
    }
  ],
  lookUpOptions: [
    {
      text: 'Gateway Table',
      value: 'gateway',
      // image: '/static/img-capmagic/file-icon.svg',
    },
    {
      text: 'Suggested Solution Table',
      value: 'suggested_solution',
      // image: '/static/img-capmagic/file-icon.svg',
    },
    {
      text: 'Solution Model Table',
      value: 'solution_model',
      // image: '/static/img-capmagic/file-icon.svg',
    },
  ],
  stringOperatorList: [
    {
      text: 'equal',
      value: 'equal'
    },
    {
      text: 'Not Equal',
      value: 'not_equal'
    },
    {
      text: 'Contains',
      value: 'contains'
    },
    {
      text: 'Not Contains',
      value: 'not_contains'
    }
  ],
  numericOperatorList: [
    {
      text: 'equal',
      value: 'equal'
    },
    {
      text: 'Not Equal',
      value: 'not_equal'
    },
    {
      text: 'Less Than',
      value: 'less_than'
    },
    {
      text: 'Less than or equal',
      value: 'less_or_equal'
    },
    {
      text: 'Greater Than',
      value: 'greater_than'
    },
    {
      text: 'Greater than or equal',
      value: 'greater_or_equal'
    }
  ],
  suggestedSolutionList: [
    {
      text: 'CMS',
      value: 'CMS'
    },
    {
      text: 'Network',
      value: 'Network'
    },
    {
      text: 'Gateway',
      value: 'Gateway'
    },
    {
      text: 'Axon',
      value: 'Axon'
    },
    {
      text: 'Neuron VS (Fixed)',
      value: 'Neuron VS (Fixed)'
    },
    {
      text: 'Neuron VS (Mobile)',
      value: 'Neuron VS (Mobile)'
    },
    {
      text: 'Neuron CX',
      value: 'Neuron CX'
    },
    {
      text: 'WiFi (802.11)',
      value: 'WiFi (802.11)'
    },
    {
      text: 'N/A',
      value: 'N/A'
    }
  ],
  exportMessages: {
    exportSuccess: "File Exported Successfully.",
    exportError: "There is an issue exporting. Please try again.",
    commonLoadingMessage: "Generating the solution, please wait...",
  },
  catchErrorMessage: "Oops! something went wrong. Please try again later.",
  countTypeList: [
    {
      countKey: 'bed',
      label: 'Bed'
    },
    {
      countKey: 'mobile_device',
      label: 'Mobile Device'
    },
    {
      countKey: 'spot_check_monitor',
      label: 'Spot Check Monitor'
    },
    {
      countKey: 'anesthesia_machine',
      label: 'Anesthesia Machine'
    }
  ],
  solutionModelArr: {
    axon: [
      { connection: 'Serial', application: 'Vitals Stream', suggested_solution: 'Axon', solution_model: 'Axon 120' }, // ask from user "solution model"
      { connection: 'via Dock/Rack', application: 'Vitals Stream', suggested_solution: 'Axon', solution_model: 'Axon 120' }, // ask from user "solution model"
      { connection: '', application: '', suggested_solution: '', solution_model: '' }
    ],
    neuron: [
      { connection: 'Serial', application: 'Vitals Stream', suggested_solution: 'Neuron VS (Fixed)', solution_model: 'Neuron IO VS Mob' }, // ask from user "solution model"
      { connection: 'via Dock/Rack', application: 'Vitals Stream', suggested_solution: 'Neuron VS (Fixed)', solution_model: 'Neuron IO VS Mob' }, // ask from user "solution model"
      { connection: '', application: '', suggested_solution: '', solution_model: '' }
    ],
    mixed: [//axon in all location & nueron in spot check monitor | Show only axon model in 2nd dropdown
      { connection: 'Serial', application: 'Chart Xpress', suggested_solution: 'Neuron CX', solution_model: 'Neuron IO CX' },// no change hardcode no changes
      { connection: 'Serial', application: 'Vitals Stream', suggested_solution: 'Axon', solution_model: 'Axon 420' }, // ask from user "solution model"
      { connection: 'via Dock/Rack', application: 'Vitals Stream', suggested_solution: 'Axon', solution_model: 'Axon 420' } // ask from user "solution model"
    ],
    mix_neuron_vs_all_location_and_nueron_cx_for_spotcheck_monitor: [//axon in all location & nueron in spot check monitor | Show only axon model in 2nd dropdown // TODO add this option.
      { connection: 'Serial', application: 'Chart Xpress', suggested_solution: 'Neuron CX', solution_model: 'Neuron IO CX' },
      { connection: 'Serial', application: 'Vitals Stream', suggested_solution: 'Neuron VS (Fixed)', solution_model: 'Neuron IO VS Mob' }, // ask from user "solution model"
      { connection: 'via Dock/Rack', application: 'Vitals Stream', suggested_solution: 'Neuron VS (Fixed)', solution_model: 'Neuron IO VS Mob' } // ask from user "solution model"
    ],
    default: [
      { connection: '', application: '', suggested_solution: '', solution_model: '' },
      { connection: '', application: '', suggested_solution: '', solution_model: '' },
      { connection: '', application: '', suggested_solution: '', solution_model: '' }
    ]
  },
  siteAssessmentEntity: {
    newSiteAssessment: 'new-site-assess',
    blankSiteAssessment: 'blank-site-assess',
    ioSiteAssessment: 'input-output',
    outputSiteAssessment: 'output',
  },
  apiResStatus: {
    success: "success",
    error: "error"
  },
  userType: {
    admin: 1,
    user: 2
  },
  dataSources: {
    configurationPackage: 'Configuration Package',
    customerPortal: 'Customer Portal'
  },
  licenseTrackerStatus: {
    extracting: {
      label: 'Extracting',
      customClass: 'bg-yellow-400',
      severity: "warning"
    },
    analyzing: {
      label: 'Analyzing',
      customClass: 'bg-yellow-400',
      severity: "warning"
    },
    completed: {
      label: 'Completed',
      customClass: 'bg-green-400',
      severity: "success"
    },
    invalid_file: {
      label: 'Invalid File',
      customClass: 'bg-red-400',
      severity: "danger"
    }
  },
}